import {register} from '@shopify/theme-sections';

import $ from 'jquery';
import {util} from '../lib/util';

register('plan-selector-v2', {
  onLoad() {
    this.$section = $('#plan-selector-v2');
    this.$defaultPlan = this.$section.find('.plan[data-default=true]');

    this.$section.find('.plan.selector-item').on('click', (e) => {
      this.dispatchPlanChange($(e.currentTarget).data());
    });

    this.$section.find('.continue-btn').on('click', (e) => {
      e.preventDefault();
      const flow = window.mosaic.views.state.flow;
      const nextStep = window.mosaic.views.flows[flow].map((view) => view[0]).indexOf('plan-selector-v2') + 2;
      window.mosaic.views.nextStep(flow, nextStep, () => {
        window.basket.empty();
        setTimeout(
          () => this.dispatchPlanChange(this.selectedPlan, true),
          500,
        );

        util.insertUrlParam('step', `${nextStep}`);
      });
    });

    document.addEventListener(
      'plan-v2:selected',
      this.processPlanChange.bind(this),
    );

    if (!this.selectedPlan) { this.selectDefaultPlan(); }

    const displayShipping = window.basket.getDisplayShipping();
    this.$section.find('.plan').each((_i, plan) => {
      const $plan = $(plan);
      const $data = $plan.data();
      const discountAmount = $data.discountAmount;

      let savings;
      if ($data.itemQuantity === 12) {
        savings = `$${Math.ceil(Number(displayShipping / 100))} savings`;
        $plan.find('.savings-amount').text(savings);
      }
      if ($data.itemQuantity === 18) {
        savings = `$${Math.ceil(Number((displayShipping + discountAmount) / 100))} savings`;
        $plan.find('.savings-amount').text(savings);
      }

      if (savings) {
        $plan.find('.savings-amount').text(savings);
      }
    });
  },

  dispatchPlanChange(planData, initial = false) {
    const planEvent = new CustomEvent('plan-v2:selected', {detail: {response: planData, initial}});
    document.dispatchEvent(planEvent);
  },

  selectDefaultPlan() {
    this.dispatchPlanChange(this.$defaultPlan.data());
  },

  processPlanChange(planChangeEvent) {
    const {detail: {response}} = planChangeEvent;

    if (!response) { return; }
    this.selectedPlan = response;
    const $selectedPlan = this.$section.find(`.plan[data-id=${response.id}]`);
    const selectedPlanClass = 'selected-plan';
    const selectedIconClass = 'fas fa-check-circle';
    const unselectedIconClass = 'fa fa-circle-thin';
    $selectedPlan.addClass(selectedPlanClass);
    $selectedPlan.attr('tabindex', '0');
    $selectedPlan.attr('aria-checked', 'true');
    $selectedPlan.find('.selection-icon').removeClass(unselectedIconClass);
    $selectedPlan.find('.selection-icon').addClass(selectedIconClass);
    this.$section.find(`.plan:not([data-id=${response.id}])`).each((_i, plan) => {
      $(plan).removeClass(selectedPlanClass);
      $(plan).attr('tabindex', '-1');
      $(plan).attr('aria-checked', 'false');
      $(plan).find('.selection-icon').removeClass(selectedIconClass);
      $(plan).find('.selection-icon').addClass(unselectedIconClass);
    });
  },
});
